import React from 'react';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { MoreFormatter } from '../../../utils/formatters';
import { addEventLogColumns, eventLogColumns } from '../constants';

export default function EventLogGrid(props) {
  const {
    data = [],
    loadData = () => {},
    onClickByRow = () => {},
    meta = {},
    name = 'elp-list-v2',
    columns = [],
  } = props;

  return (
    <div className="elp-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid className="elp-grid" data={data} columns={columns.length ? columns : eventLogColumns} additionalColumns={addEventLogColumns} onClickByRow={onClickByRow} name={name} settingsFormatter={MoreFormatter} />
        </div>
      </div>
      <Pagination meta={meta} list={data} handleChangeMeta={loadData} />
    </div>
  );
}
